import './Body.css';
import BodyNav from './BodyNav';
import BodyContent from './BodyContent';

const Body = () => {
  return (
    <main>
      <BodyNav />
      <BodyContent />
    </main>
  );
};

export default Body;

